import React from "react";
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'
import Home from './Home'
import Projects from './Projects'
import Chat from './Chat'
import $ from 'jquery'
import './Styles/Nav.css'

export default function Nav() {
  function openNav() {
    $("#myNav").css("width", "100%")
  }

  function closeNav() {
    $("#myNav").css("width", "0%")
  }

 
  return (
    <div>
      <Router>
        <div id="myNav" className="overlay">
          <a className="btn" onClick={closeNav}>&times;</a>
          <div className="overlay-content">
            <Link onClick={closeNav} className="nav-link text-center" to="/"><b>Home</b></Link>
            <Link onClick={closeNav} className="nav-link text-center" to="/Projects"><b>Projects</b></Link>
            <Link onClick={closeNav} className="nav-link text-center" to="/Chat"><b>Chat</b></Link>
          </div>
        </div><br /><br />


        <span className="btn fixed-top w-25 float-right " onClick={openNav}><h1 className="display-3"><img className="menu_icon" src="./Images/icons/menu_icon.svg" alt=""/></h1></span>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Projects" component={Projects} />
          <Route path="/Chat" component={Chat} />

        </Switch>
      </Router>
    </div>
  );
}
